(() => {
  document.querySelectorAll('[data-aathi-product]').forEach(section => {
    if (section.dataset.uxReady) return;
    section.dataset.uxReady = 'true';
    const dataNode = section.querySelector('[data-ux-product]');
    if (!dataNode) return;
    const product = JSON.parse(dataNode.textContent);
    const key = 'aathi-wishlist-v1';
    const save = section.querySelector('[data-ux-save]');
    const status = section.querySelector('[data-ux-message]');
    const dialog = section.querySelector('[data-ux-saved]');
    const list = section.querySelector('[data-ux-saved-list]');
    const read = () => {
      try { const value = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(value) ? value.filter(p => p && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i.test(p.url)).slice(0,50) : []; } catch { return []; }
    };
    const write = items => {
      try { localStorage.setItem(key, JSON.stringify(items)); return true; }
      catch { status.textContent = product.storageFailed; return false; }
    };
    const sync = () => { const saved = read().some(p => p.id === product.id); save.setAttribute('aria-pressed', String(saved)); save.setAttribute('aria-label', saved ? product.saved : product.save); save.title = saved ? product.saved : product.save; };
    const render = () => {
      list.replaceChildren();
      const items = read();
      if (!items.length) { list.textContent = product.empty; return; }
      items.forEach(item => {
        const row = document.createElement('div'); row.className = 'aathi-ux-saved-row';
        const link = document.createElement('a'); link.href = item.url; link.textContent = item.title;
        const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = product.remove; remove.setAttribute('aria-label', product.remove + ' ' + item.title);
        remove.addEventListener('click', () => { if (write(read().filter(p => p.id !== item.id))) { render(); sync(); } });
        row.append(link, remove); list.append(row);
      });
    };
    save.addEventListener('click', () => {
      const items = read(); const exists = items.some(p => p.id === product.id);
      const next = exists ? items.filter(p => p.id !== product.id) : [{id:product.id,title:product.title,url:product.url},...items].slice(0,50);
      if (write(next)) { sync(); status.textContent = exists ? product.remove : product.saved; }
    });
    section.querySelector('[data-ux-saved-open]')?.addEventListener('click', () => { render(); dialog.showModal(); });
    section.querySelector('[data-ux-saved-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if(e.target === dialog) { const b=dialog.getBoundingClientRect(); if(e.clientX<b.left || e.clientX>b.right || e.clientY<b.top || e.clientY>b.bottom) dialog.close(); } });
    section.querySelector('[data-ux-share]').addEventListener('click', async () => {
      const url = new URL(product.url, location.origin).href;
      if (navigator.share) { try { await navigator.share({title:product.title,url}); return; } catch (e) { if(e.name==='AbortError') return; } }
      try { await navigator.clipboard.writeText(url); status.textContent = product.copied; }
      catch { status.textContent = product.failed; }
    });
    window.addEventListener('storage', sync);
    sync();
  });
})();
